import { BaseWithId } from '../../../../api/models/base.model'

export abstract class TimeRepresentation extends BaseWithId {
    secondsToInvoice!: number
    secondsNoInvoice!: number
}
